<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="complete-buy-point" style="margin-top: 20px">
      <Title v-if="isSuccess == 1" eng="BUY POINTS" jpn="Payment Completed" />
      <Title v-if="isSuccess == 2" eng="BUY POINTS" jpn="Payment Failed" />
      <div class="area_box">
        <div class="flex-box" style="color: #fff">
          <div v-if="isSuccess == 1" class="text thanks immediate">
            <span>Thank you for purchasing points!</span>
            <span>We hope you continue to enjoy your Gacha purchases!</span>
          </div>
          <div v-if="isSuccess == 2" class="text thanks delay">
            <span>Payment failed.</span>
            <span>Please use other payment methods.</span>
          </div>
        </div>
      </div>
<!--      <div-->
<!--        v-if="isExistPackId !== null && isExistPackId && isMoreThanPackPoint"-->
<!--        class="button-area">-->
<!--        <SquareButton-->
<!--          class="square-button"-->
<!--          text="TOPへ戻る"-->
<!--          :isSub="true"-->
<!--          @handleSquareBtnClick="goToTop"-->
<!--        />-->
<!--        <BlackGradationButton-->
<!--          class="square-button"-->
<!--          text="商品購入へ"-->
<!--          @handleSquareBtnClick="goToBuyProduct"-->
<!--        />-->
<!--      </div>-->
      <BlackGradationButton
        v-if="isExistPackId !== null && (!isExistPackId || !isMoreThanPackPoint)"
        class="square-button top"
        text="HOME"
        @handleSquareBtnClick="goToTop"
      />
    </div>
  </BaseTemplate>
</template>

<script>
import Title from '@/components/molecules/Title.vue';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';

export default {
  components: {
    BaseTemplate,
    Title,
    BlackGradationButton,
  },
  data: () => ({
    isSuccess: 0,
  }),

  created() {
    if (window.location.href.indexOf('complete-carrier') > 0) {
      this.isSuccess = 1;
    } else {
      this.isSuccess = 2;
    }
  },

  methods: {
    goToTop() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-box {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.area_box {
  max-width: 680px;
  margin-left: auto;
  margin-right: auto;
}
.complete-buy-point{
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1800px;
  min-height: 100%;
  padding-top: 0px;
  margin: 0px auto;
  text-align: center;
  .text.thanks{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: $notoSans;
    font-size: 18px;
    line-height: 32.4px;
    // color: $white;
  }
  .button-area{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
    .square-button{
      width: 120px;
      height: 50px;
      & + .square-button{
        margin-left: 30px;
      }
    }
  }
  .square-button.top{
    width: 200px;
    height: 50px;
    margin: 60px auto 0px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .leaf_box {
    margin: 0 10px;
  }
}
</style>
